import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpLoginComponent} from './dcp-login/dcp-login.component';
import {CmsConfig, ConfigModule, I18nModule, NotAuthGuard, RoutingConfig, UrlModule} from '@spartacus/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormErrorsModule} from '@spartacus/storefront';

@NgModule({
  imports: [
    CommonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    ConfigModule.withConfig({
      routing: {
        routes: {
          register: {
            disabled: true,
            paths: [],
          },
        },
      },
    } as RoutingConfig),
    ConfigModule.withConfig({
      cmsComponents: {
        ReturningCustomerLoginComponent: {
          component: DcpLoginComponent,
          guards: [NotAuthGuard],
        },
        RegisterCustomerComponent: {
          // remove register component mapping
          component: '',
          guards: [],
        },
      },
    } as CmsConfig),
    DcpLoginComponent,
  ],
})
export class LoginModule {}
